export function joinPath(base: string, path: string): string {
  return `${base.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
}

export function formatLocalDate(value: string | Date, locale = 'en'): string {
  return new Intl.DateTimeFormat(locale, { dateStyle: 'medium' }).format(new Date(value));
}

export function formatCurrency(value: number | undefined, currencyCode?: string): string {
  if (!currencyCode) return Number(value ?? 0).toLocaleString('en');
  return new Intl.NumberFormat('en', {
    style: 'currency',
    currency: currencyCode,
    maximumFractionDigits: 0,
  }).format(Number(value ?? 0));
}

function dayInZone(value: string | Date, timeZone: string): number {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date(value));
  const part = (type: Intl.DateTimeFormatPartTypes) => Number(parts.find(item => item.type === type)?.value);
  return Date.UTC(part('year'), part('month') - 1, part('day'));
}

export function daysUntilReturn(value: string | Date, timeZone: string, reference: string | Date): number {
  const dueDay = dayInZone(value, timeZone);
  const todayDay = dayInZone(reference, timeZone);
  return Math.round((dueDay - todayDay) / 86_400_000);
}

export function returnDueLabel(value: string | Date, timeZone: string, reference: string | Date = new Date()): string {
  const days = daysUntilReturn(value, timeZone, reference);
  return days < 0 ? 'Return overdue' : days === 0 ? 'Return today' : days === 1 ? 'Return tomorrow' : `Return in ${days} days`;
}
